export const seoData = [
    {
        id:1,
        title: 'Boosts Your Online Credibility',
        message: "One of the best things you can do to increase your brand's credibility, trust, and ultimately reputation is to use SEO tactics. Your domain authority will rise due to more high-quality links, improving your overall keyword and ranking.",
        image: require('../images/Financial growth.svg').default
    },
    {
        id:2,
        title: 'Supports Content Marketing',
        message: "Creating helpful content for visitors, including text, images, and videos will improve your site's ranking in search engine results. Content and SEO goes hand in hand, and also help with your content marketing initiatives.",
        image: require('../images/Seo.svg').default
    },
    {
        id:3,
        title: "Improves Your Company’s Website Value",
        message: "Making your website search engine friendly, it enhance user experience for your website visitors. if you create helpful and high-quality content, and improve the responsiveness of your site, you will usually get a great website conversion in return.",
        image: require('../images/Social media.svg').default
    },
    {
        id:4,
        title: 'Reach More People',
        message: "You can connect with more potential customers who might be interested in doing business with you if you target the right keywords. SEO can help with generating leads at a given time, regardless of where they are in the buying funnel.",
        image: require('../images/Digital marketing.svg').default
    },

];

export const listData = [
    {
        id: 1,
        title: 'Keyword Research',
        message: "Conduct in-depth keyword research to identify relevant and high-performing keywords for better search engine visibility."
    },
    {
        id: 2,
        title: 'On-Page Optimization',
        message: "Optimizing of your website content, meta tags, headings, and URLs to improve search engine rankings."
    },
    {
        id: 3,
        title: 'Off-Page Optimization',
        message: "Implementing strategies to build high-quality backlinks and improve your website's authority and visibility."
    },
    {
        id: 4,
        title: 'SEO Analytics and Reporting',
        message: "Track and analyze key SEO metrics, provides insights, and delivers regular reports to measure the effectiveness of the SEO efforts."
    },
];